// Tabelas de referência (INSS/IRRF 2024, os valores mais recentes amplamente
// publicados no momento da implementação) — ajuste anual do governo pode
// mudar essas faixas, então isso é sempre uma estimativa.
const INSS_BRACKETS = [
  { upTo: 1412.0, rate: 0.075 },
  { upTo: 2666.68, rate: 0.09 },
  { upTo: 4000.03, rate: 0.12 },
  { upTo: 7786.02, rate: 0.14 },
]

const IRRF_BRACKETS = [
  { upTo: 2259.2, rate: 0, deduction: 0 },
  { upTo: 2826.65, rate: 0.075, deduction: 169.44 },
  { upTo: 3751.05, rate: 0.15, deduction: 381.44 },
  { upTo: 4664.68, rate: 0.225, deduction: 662.77 },
  { upTo: Infinity, rate: 0.275, deduction: 896.0 },
]

export const calculateInss = (gross) => {
  const ceiling = INSS_BRACKETS[INSS_BRACKETS.length - 1].upTo
  const cappedGross = Math.min(gross, ceiling)
  let total = 0
  let previousCap = 0
  for (const bracket of INSS_BRACKETS) {
    const cap = Math.min(cappedGross, bracket.upTo)
    if (cap > previousCap) {
      total += (cap - previousCap) * bracket.rate
    }
    previousCap = bracket.upTo
    if (cappedGross <= bracket.upTo) break
  }
  return total
}

export const calculateIrrf = (base) => {
  const bracket = IRRF_BRACKETS.find((b) => base <= b.upTo)
  const value = base * bracket.rate - bracket.deduction
  return Math.max(0, value)
}

export const calculateNetSalary = ({ gross, dependents = 0 }) => {
  const inss = calculateInss(gross)
  const dependentDeduction = dependents * 189.59
  const irrfBase = Math.max(0, gross - inss - dependentDeduction)
  const irrf = calculateIrrf(irrfBase)
  const net = gross - inss - irrf
  return { gross, inss, irrf, irrfBase, net }
}
